interface SidebarAddButtonProps {
  title: string
  onClick: () => void
}

/** The small square "+" affordance beside a sidebar section label. */
export function SidebarAddButton({ title, onClick }: SidebarAddButtonProps) {
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      onClick={onClick}
      className="flex h-[22px] w-[22px] flex-none items-center justify-center rounded-[6px] border border-line bg-paper-surface font-sans text-[15px] leading-none text-ink-muted transition-colors hover:border-terra hover:text-terra-deep"
    >
      +
    </button>
  )
}
